import React, {useEffect} from 'react'
import {css} from "@emotion/css";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {useState} from "react";
import ChangePasswordCardComponent from "../../component/changePassword/ChangePasswordCardComponent";
import UserProfileDetailPage from "../../component/userProfileDetail/UserProfileDetailPage";
import ChangeUserName from "../../component/ChangeUserName/ChangeUserName";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ProfileService} from "./ProfileService";
import {RouteInfo} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";

const Profile = () => {

    const loading = new LoadingHelper(useLoadingDispatcher())


    const service = new ProfileService()

    const [profileDetail, setProfileDetail] = useState({});
    const [avatarFile, setAvatarFile] = useState([])
    const [avatarLoadingState, setAvatarLoadingState] = useState(false);

    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
            // getAvatarFromServer()
        }
    }, [])


    function getDataFromServer() {
        loading.show()
        service.getProfileDetail()
            .then(response => {
                setProfileDetail(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    // function getAvatarFromServer() {
    //     loading.show()
    //
    //     setAvatarLoadingState(true)
    //     service.getAvatarAdmin()
    //         .then(response => {
    //             setAvatarFile(response.downloadUrl)
    //         }).catch(reason => {
    //         showErrorMessage(detectServerErrorMessage(reason))
    //     }).finally(_ => {
    //         setAvatarLoadingState(false)
    //         loading.hide()
    //     })
    // }


    const [pageTitle, setPageTitle] = useState(RouteInfo.Profile.name);
    const [pageSubTitle, setPageSubTitle] = useState(ProfileTabTypes.ProfileContent.title)
    const [value, setValue] = useState(ProfileTabTypes.ProfileContent.id);

    const handleChange = (event, newValue) => {
        switch (newValue) {
            case ProfileTabTypes.ProfileContent.id:
                setPageSubTitle(ProfileTabTypes.ProfileContent.title);
                break;
            // case ProfileTabTypes.ChangeUsername.id:
            //     setPageSubTitle(ProfileTabTypes.ChangeUsername.title)
            //     break;
            case ProfileTabTypes.Password.id:
                setPageSubTitle(ProfileTabTypes.Password.title)
                break;
        }
        setValue(newValue);
    };

    function doChangePassword() {

    }

    return (
        <>
            <Helmet>
                <title className="">{RouteInfo.Profile.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        RouteInfo.ManagersList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageSubTitle,
                        ""
                    )
                ]}/>
                <TabContext value={value}>
                    <Box
                        sx={{borderBottom: 1, borderColor: 'divider'}}
                        className={css`
                          border-color: var(--header-border-bottom-color) !important;
                          margin-top: 24px;
                        `}>
                        <TabList onChange={handleChange} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon" className={"ic-profile"}/>} iconPosition="start"
                                 label="جزئیات حساب"
                                 value={ProfileTabTypes.ProfileContent.id}/>
                            {/*<Tab icon={<div id="tabIcon" className={"ic-key"}/>} iconPosition="start"*/}
                            {/*     label={ProfileTabTypes.ChangeUsername.title}*/}
                            {/*     value={ProfileTabTypes.ChangeUsername.id}/>*/}
                            <Tab icon={<div id="tabIcon" className={"ic-security"}/>} iconPosition="start"
                                 label="رمز عبور"
                                 value={ProfileTabTypes.Password.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={ProfileTabTypes.ProfileContent.id}>
                        <UserProfileDetailPage
                            profileDetail={profileDetail}
                            setProfileDetail={setProfileDetail}
                            // avatarFile={avatarFile}
                            // setAvatarFile={setAvatarFile}
                            service={service}
                            // avatarLoadingState={avatarLoadingState}
                        />
                    </TabPanel>
                    {/*<TabPanel value={ProfileTabTypes.ChangeUsername.id}>*/}
                    {/*    <ChangeUserName service={service}/>*/}
                    {/*</TabPanel>*/}
                    <TabPanel value={ProfileTabTypes.Password.id}>
                        <ChangePasswordCardComponent
                            service={service}
                            doChangePassword={doChangePassword}
                        />
                    </TabPanel>
                </TabContext>

            </RaikoBaseContainer>
        </>


    )
}

export default Profile

const ProfileTabTypes = {
    ProfileContent: {
        id: "profile-content",
        title: "جزئیات حساب"
    },
    // ChangeUsername: {
    //     id: "change-username",
    //     title: "نام کاربری"
    // },
    Password: {
        id: "password",
        title: "رمز عبور"
    },
}